import { render, staticRenderFns } from "./CreatepaintworkformPage.vue?vue&type=template&id=1f43800c"
import script from "./CreatepaintworkformPage.vue?vue&type=script&lang=js"
export * from "./CreatepaintworkformPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports